import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import './LegendIcon.css';
import { LegendIconProps } from '../../types/components/legend';
import { DEFAULT_CIRCLE_OPACITY, DEFAULT_COLOR, DEFAULT_FILL_OPACITY } from '../../constants/mapStyle';


// HEXカラーコードをRGBA形式に変換する関数
const hexToRgba = (hex: string, opacity: number) => {
    // rgbaまたはrgbが渡されたらそのまま返す
    if (/^rgba?\(/.test(hex)) {
        return hex;
    }
    const sanitizedHex = hex.replace('#', '');
    const bigint = parseInt(sanitizedHex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
  
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

const legendClassName = {
    fill: 'polygon',
    stroke: 'line',
    marker_color: 'point',
    'marker-color': 'point',
    'marker-symbol': 'sprite',
    isAlert: 'alert',
}


const LegendIcon: React.FC<LegendIconProps> = ({ type, value, small }) => {

    const backgroundColor = type === 'fill' ? 
            hexToRgba(value??DEFAULT_COLOR, DEFAULT_FILL_OPACITY) 
            : 
            (type === 'marker_color' || type === 'marker-color') ? 
                hexToRgba(value??DEFAULT_COLOR, DEFAULT_CIRCLE_OPACITY) 
                : 
                value;

    const [spriteData, setSpriteData] = useState<{ [key: string]: { x: number; y: number; width: number; height: number, pixelRatio: number } } | null>(null);


    useEffect(() => {
      // JSONファイルをフェッチしてデータを取得
      fetch('https://geolonia.github.io/custom-smartmap-sprite/sprite.json')
        .then(response => response.json())
        .then(data => setSpriteData(data))
        .catch(error => console.error('Error fetching sprite data:', error));
    }, []);


    const spriteInfo = (spriteData && type === 'marker-symbol') ? spriteData[value] : null;
    const parentHeight = spriteInfo ? spriteInfo.height * 0.5 : undefined;
    const parentWidth = spriteInfo ? spriteInfo.width * 0.5 : undefined;

    return (
        <div className={classNames('legend-icon', {small: small})} style={{height: parentHeight, width: parentWidth}}>
            { /*** アラート ***/
                type === 'isAlert' && <p>ポップアップにて表示</p> 
            }
            { /*** アイコン ***/
                (type === 'marker-symbol' && spriteInfo) && 
                    <div
                        className={ classNames({[legendClassName[type]]: type}) } 
                        style={{
                            width: `${spriteInfo?.width}px`,
                            height: `${spriteInfo?.height}px`,
                            backgroundImage: `url('https://geolonia.github.io/custom-smartmap-sprite/sprite.png')`,
                            backgroundPosition: `-${spriteInfo?.x}px -${spriteInfo?.y}px`
                        }}
                    />
            }
            { /*** それ以外 ***/
                ((type !== 'isAlert' && type !== 'marker-symbol') || !spriteInfo ) &&
                    <div 
                        className={ classNames({[legendClassName[type]]: type}) } 
                        style={{ backgroundColor: backgroundColor, borderColor: value??DEFAULT_COLOR }}
                    ></div>
            }
        </div>
    );
};

export default LegendIcon;
